export const credentials = [
  {
    name: 'Administrador',
    gerente: 'Admin',
    email: 'admin@matsuya.com.br',
    password: 'Admin2025$$',
  },
  {
    name: 'Aclimação',
    gerente: 'Dinailton',
    email: 'aclimacao@matsuya.com.br',
    password: 'dTyKKyN6P3FzdtG6',
  },
  {
    name: 'Moema',
    gerente: 'Marcos',
    email: 'moema@matsuya.com.br',
    password: 'PEH6x2D5zZSxCag3',
  },
  {
    name: 'Mooca',
    gerente: 'Livia',
    email: 'mooca@matsuya.com.br',
    password: 'matsuyamooca2025$',
  },
  {
    name: 'Morumbi',
    gerente: 'Cafu',
    email: 'morumbi@matsuya.com.br',
    password: '367367',
  },
  {
    name: 'Perdizes',
    gerente: 'Edison',
    email: 'perdizes@matsuya.com.br',
    password: 'Perdizes99',
  },
  {
    name: 'Santana',
    gerente: 'Romário',
    email: 'santana@matsuya.com.br',
    password: 'qO2uj1N2JaBY6i1d',
  },
  {
    name: 'Saúde',
    gerente: 'Wodson',
    email: 'saude@matsuya.com.br',
    password: 'ZEaMA1D8BsiQK2YZ',
  },
  {
    name: 'Vila Mariana',
    gerente: 'Júnior',
    email: 'vilamariana@matsuya.com.br',
    password: 'CEkf10QWmEZobNdO',
  },
  {
    name: 'Guarulhos',
    gerente: 'Rafael',
    email: 'guarulhos@matsuya.com.br',
    password: 'CEkf10QWmEZobNdO',
  },
];
